






















declare const componentHandler: any;
import { Prop, Component, Emit } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Mixin from '../mixin';

@Component
export default class ListDecorator extends Mixin {
  @Prop() public extraCommand: string | undefined;
  @State private showOrg!: any;
  private counter: number = 0;
  private done: boolean = false;

  private get extraStr() {
    return this.extraCommand || '';
  }

  @Emit() private extra() {
    return;
  }
  @Emit() private add() { return; }
  @Emit() private del() {
    const input = (this.$el.querySelector('th input:first-of-type') as HTMLInputElement);
    input.checked = false;
    input.parentElement!.classList.remove('is-checked');
    return;
  }

  @Emit() private scroll(event: any): any { return event; }

  @Emit()
  private reload(): (f: () => Promise<any>) => void {
    return (async (f: () => Promise<any>) => {
      const reload = this.$el.querySelector('.reload') as HTMLElement;
      reload.classList.remove('done');
      reload.classList.add('spin');
      await f();
      reload.classList.remove('spin');
      reload.classList.add('done');
    });
  }

  private mounted() {
    const th = (this.$el.querySelector('thead tr') as Element);
    const htd = document.createElement('th');
    htd.className = 'mdl-data-table__cell--non-numeric';
    const hch = document.createElement('input');
    hch.setAttribute('type', 'checkbox');
    hch.className = 'mdl-checkbox__input';
    hch.id = (this as any)._uid + 'checkbox_th';
    const hlb = document.createElement('label');
    hlb.setAttribute('for', hch.id);
    hlb.className = 'mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect';
    hlb.appendChild(hch);
    hlb.addEventListener('click', (event) => {
      event.stopPropagation();
      const value = (hch as HTMLInputElement).checked;
      const checkboxes = this.$el.querySelectorAll('tbody tr td:first-of-type .mdl-checkbox');
      checkboxes.forEach((el) => {
        if (el.classList.contains('is-disabled')) {
          return;
        }
        ((el as Element).querySelector('input[type="checkbox"]') as HTMLInputElement).checked = value;
        if (value) {
          (el as Element).classList.add('is-checked');
        } else {
          (el as Element).classList.remove('is-checked');
        }
      });
      this.updateCounter();
    });
    htd.appendChild(hlb);
    th.insertBefore(htd, th.firstChild);
    const proc = (n: any, i: any) => {
      const el = n as Element;
      if (el.tagName === 'TR') {
        if (el.querySelectorAll('td:first-of-type .mdl-checkbox').length > 0) {
          return;
        }
        const num = Math.random();
        const td = document.createElement('td');
        td.className = 'mdl-data-table__cell--non-numeric';
        td.addEventListener('click', (event) => {
          event.stopPropagation();
        });
        const ch = document.createElement('input');
        ch.setAttribute('type', 'checkbox');
        ch.className = 'mdl-checkbox__input';
        ch.id = 'checkbox' + num;
        if (el.getAttribute('disabled') === 'disabled') {
          ch.classList.add('is-disabled');
          ch.disabled = true;
        }
        ch.addEventListener('click', (event) => {
          event.stopPropagation();
          this.updateCounter();
          const len = Array.from(this.$el.querySelectorAll('tbody tr td:first-of-type input[type="checkbox"]')).length;
          if (this.counter !== len) {
            const input = (this.$el.querySelector('th input:first-of-type') as HTMLInputElement);
            input.checked = false;
            input.parentElement!.classList.remove('is-checked');
          }
        });
        const lb = document.createElement('label');
        lb.setAttribute('for', ch.id);
        lb.className = 'mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect';
        lb.appendChild(ch);
        td.appendChild(lb);
        n.insertBefore(td, n.firstChild);
      }
    };
    this.$el.querySelectorAll('tbody tr').forEach(proc);
    const observer = new MutationObserver((record, mutation) => {
      record.forEach((r) => {
        r.addedNodes.forEach(proc);
      });
      componentHandler.upgradeDom();
      this.updateCounter();
    });
    observer.observe(this.$el.querySelector('table') as any, {childList: true, subtree: true});
  }

  private updateCounter() {
    this.counter = Array.from(this.$el.querySelectorAll('tbody tr td:first-of-type input[type="checkbox"]'))
      .filter((el, index, array) => (el as HTMLInputElement).checked).length;
  }

}
